import { defineComponent as n, openBlock as o, createElementBlock as c, createElementVNode as t, normalizeClass as a, createVNode as i, createBlock as l, createCommentVNode as r, toDisplayString as d } from "vue";
import p from "./index68.js";
import m from "./index62.js";
const _ = {
  class: "icon-skeleton",
  role: "status"
}, f = { class: "icon-skeleton-container" }, k = { class: "sr-only" }, y = /* @__PURE__ */ n({
  __name: "IconSkeleton",
  props: {
    size: { default: "md" },
    showText: { type: Boolean, default: !1 },
    text: { default: "Loading..." }
  },
  setup(s) {
    const e = s;
    return (u, x) => (o(), c("div", _, [
      t("div", f, [
        t("div", {
          class: a(`icon-skeleton-svg icon-skeleton-${e.size}`)
        }, [
          i(p, {
            type: "user",
            size: e.size
          }, null, 8, ["size"])
        ], 2),
        e.showText ? (o(), l(m, {
          key: 0,
          width: "60px",
          height: "12px",
          variant: "text",
          class: "icon-skeleton-text"
        })) : r("", !0)
      ]),
      t("span", k, d(e.text), 1)
    ]));
  }
});
export {
  y as default
};
